/**
 * T-226: a time zone saved by the sign-in fill (useTimeZonePrefill) is announced on the
 * page, so a Profile page that read "not set" a moment earlier shows it without a reload.
 */
const EVENT = 'ht:time-zone-saved';

export function announceTimeZoneSaved(timeZone: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: timeZone }));
}

/** @returns a function that stops listening. */
export function onTimeZoneSaved(listener: (timeZone: string) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handle = (e: Event) => {
    const tz = (e as CustomEvent<unknown>).detail;
    if (typeof tz === 'string' && tz) listener(tz);
  };
  window.addEventListener(EVENT, handle);
  return () => window.removeEventListener(EVENT, handle);
}
